import Vue from 'vue';
import VueGtag from 'vue-gtag';
import router from '../router';

Vue.use(
  VueGtag,
  {
    config: {
      id: 'G-G3H45HQ8D7',
    },
    appName: 'XRobotmon',
    // pageTrackerScreenviewEnabled: true,
  },
  router
);
